import React from "react";
import { useNavigate } from "react-router-dom";
import ImageWithLoader from "../components/ImageWithLoader";

const images = [
  "/g1.png",
  "/g2.png",
  "/g3.png",
  "/g4.png",
  "/g5.png",
  "/g6.png",
];

export default function Gallery1() {
  const navigate = useNavigate();

  return (
    <section className="relative py-24 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#2b1a0d] via-[#5a3b1a] to-[#1a0f07]" />

      <div className="max-w-6xl mx-auto px-6 relative z-10">
        <div className="mb-12 text-center">
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-white font-bold">
            Our Farm Gallery
          </h2>
          <p className="text-yellow-200/80 mt-4">
            A glimpse into GEA FARM
          </p>
        </div>

        {/* GRID */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          {images.slice(0, 6).map((src, i) => (
            <div key={i} className="group rounded-xl overflow-hidden">
              <ImageWithLoader
                src={src}
                alt={`gallery-${i}`}
                className="h-[180px] md:h-[220px]"
              />

              {/* Hover overlay */}
              <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition pointer-events-none" />
            </div>
          ))}
        </div>

        {/* BUTTON */}
        <div className="text-center mt-10">
          <button
            onClick={() => navigate("/gallery")}
            className="bg-yellow-500 hover:bg-yellow-600 text-black font-semibold px-8 py-3 rounded-xl transition-all duration-200 hover:-translate-y-0.5"
          >
            View More →
          </button>
        </div>
      </div>
    </section>
  );
}